import { HttpClientBuilder } from './http-client-builder';

export const ServerClient = new HttpClientBuilder().create();
